import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthorizationService } from 'services/authorization.service';
import { CLAIM_SCOPES, CLAIM_TYPES, PolicyType } from 'types/user.interface';
import { checkClaims, isAdminUser } from 'util/user.utility';
@Injectable({
  providedIn: 'root'
})
export class ClaimsGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthorizationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const policyType = route.data['policyType'] as PolicyType[];

    const isAdminOnly = route.data['isAdminOnly'];

    if (!policyType) {
      return true; // No policy type required
    }

    const hasRequiredClaims = policyType.every((policyType) => checkClaims(policyType, CLAIM_TYPES['read']));

    if (!hasRequiredClaims) {
      if (this.isOwnProfileAccess(route, policyType)) {
        return true;
      }
      this.router.navigate(['/']);
      return false;
    }

    if (isAdminOnly && !isAdminUser()) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }

  private isOwnProfileAccess(route: ActivatedRouteSnapshot, policyTypes: PolicyType[]): boolean {
    if (!policyTypes.includes(CLAIM_SCOPES['user'])) return false;
    const routeUserId = route.params['id'];
    if (!routeUserId) return false;
    return routeUserId === this.authService.getUserId() && checkClaims(CLAIM_SCOPES['myProfile'], CLAIM_TYPES['read']);
  }
}
